type RecordLike = Record<string, unknown>;

const pickFirst = (...values: (string | undefined | null)[]) => {
  for (const v of values) {
    if (typeof v === "string" && v.trim()) return v.trim();
  }
  return "";
};

export const mediaSources = (base: string) =>
  [`${base}AZ`, `${base}RU`, `${base}EN`, base] as const;

/**
 * Обязательный файл: достаточно значения в любом источнике группы —
 * базовая колонка или любая из языковых (записи, созданные до
 * появления per-lang колонок, хранят файл только в базовой).
 */
export const mediaRequired =
  (base: string) =>
  (_value: unknown, allValues: Record<string, unknown>): string | undefined =>
    mediaSources(base).some((src) => pickFirst(allValues?.[src] as string))
      ? undefined
      : "Обязательное поле";

export const isSameMediaForAllLangs = (record: RecordLike, base: string) => {
  const legacy = pickFirst(record[base] as string);
  const az = pickFirst(record[`${base}AZ`] as string, legacy);
  const ru = pickFirst(record[`${base}RU`] as string, legacy);
  const en = pickFirst(record[`${base}EN`] as string, legacy);
  if (!az && !ru && !en) return true;
  return az === ru && ru === en;
};

export const normalizeLocalizedMedia = (record: RecordLike, base: string) => {
  const legacy = pickFirst(record[base] as string);
  let az = pickFirst(record[`${base}AZ`] as string, legacy);
  let ru = pickFirst(record[`${base}RU`] as string, legacy);
  let en = pickFirst(record[`${base}EN`] as string, legacy);
  const primary = pickFirst(ru, az, en, legacy);
  if (!az) az = primary;
  if (!ru) ru = primary;
  if (!en) en = primary;
  record[`${base}AZ`] = az;
  record[`${base}RU`] = ru;
  record[`${base}EN`] = en;
  record[base] = primary;
  return record;
};

export const normalizeContentRecord = (record: RecordLike) => {
  normalizeLocalizedMedia(record, "Image");
  if ("Video" in record || "VideoAZ" in record) {
    normalizeLocalizedMedia(record, "Video");
  }
  if ("Filename" in record || "FilenameAZ" in record) {
    normalizeLocalizedMedia(record, "Filename");
  }
  if ("BackgroundMusic" in record || "BackgroundMusicAZ" in record) {
    normalizeLocalizedMedia(record, "BackgroundMusic");
  }
  const color = record.TextColor ?? record.textColor;
  if (typeof color === "string" && color.trim()) {
    const trimmed = color.trim().startsWith("#") ? color.trim() : `#${color.trim()}`;
    record.TextColor = trimmed.toUpperCase();
    delete record.textColor;
  }
  for (const key of Object.keys(record)) {
    if (key.startsWith("_same")) {
      delete record[key];
    }
  }
  return record;
};

export const normalizePhraseRecord = (record: RecordLike) => {
  normalizeLocalizedMedia(record, "Background");
  const color = record.TextColor ?? record.textColor;
  if (typeof color === "string" && color.trim()) {
    const trimmed = color.trim().startsWith("#") ? color.trim() : `#${color.trim()}`;
    record.TextColor = trimmed.toUpperCase();
    delete record.textColor;
  }
  for (const key of Object.keys(record)) {
    if (key.startsWith("_same")) {
      delete record[key];
    }
  }
  return record;
};
